<div class="container">
  <div class="top-container">
    <div [dtScrollbar]="nl" #scrollbar="dtScrollbar" class="navigation-container">
      <ul #nl class="navigation-list">
        <div class="decision-question">
          <div class="decision-statement-container mat-elevation-z4" [class.folded]="!isUnfolded">
            <span i18n [class.italic]="!decisionData.decisionStatement.statement"
              >{{ decisionData.decisionStatement.statement || 'Keine Entscheidungsfrage definiert' }}
            </span>
          </div>
        </div>
        <!-- navigation/steps -->
        <div class="steps-container" [class.disabled]="!isProjectLoaded()">
          @for (step of steps; track step; let stepIndex = $index) {
            <div
              class="step"
              routerLinkActive="active"
              #stepLink="routerLinkActive"
              [class.disabled]="!isProjectLoaded()"
              [attr.data-cy]="'step-' + step.id"
            >
              @if (stepIndex + 1 !== 6 && isUnfolded) {
                <dt-note-btn
                  [(comment)]="decisionData.stepExplanations[step.id]"
                  [darkBackground]="true"
                  [caption]="step.name | noteBtnPreset: 'step'"
                  [readonly]="decisionDataState.isProjectReadonly"
                >
                  <dt-team-comments additional-modal-content [object]="{ uuid: TeamUUIDs.STEPS[step.id] }"> </dt-team-comments>
                </dt-note-btn>
              }
              <div
                class="step-part-main"
                (click)="toStep(step.id)"
                [class.active]="stepLink.isActive"
                [routerLink]="step.routerLink"
                [title]="!isUnfolded ? step.name : ''"
              >
                <div class="left-container">
                  <mat-icon>{{ step.icon }}</mat-icon>
                </div>
                <!-- right side (menu items) -->
                @if (isUnfolded) {
                  <div class="right-container">
                    <!-- step name -->
                    <div role="link" class="step-name">
                      {{ stepIndex + 1 !== 6 ? stepIndex + 1 + ' | ' + step.name : step.name }}
                    </div>
                  </div>
                }
              </div>
              @if (step | filteredSubSteps: decisionData.projectMode; as subSteps) {
                <div [class.folded-sidenav]="!isUnfolded" class="step-part-sub">
                  <!-- sub menu if needed -->
                  @if (stepLink.isActive && subSteps.length > 0) {
                    <ul class="sub-menu">
                      @for (subStep of subSteps; track subStep) {
                        <li
                          role="link"
                          [routerLink]="step.routerLink + '/steps/' + (subStep.index + 1)"
                          routerLinkActive="active"
                          [class.done]="isSubStepDone({ step: step.id, subStepIndex: subStep.index })"
                          [class.current]="isSubStepCurrent({ step: step.id, subStepIndex: subStep.index })"
                          [attr.data-cy]="'substep-' + subStep.index"
                        >
                          <div [title]="!isUnfolded ? subStep.name : ''" class="progress-part">
                            <div class="line"></div>
                            <div class="circle">
                              <mat-icon class="check">check</mat-icon>
                              <mat-icon class="arrow">keyboard_arrow_right</mat-icon>
                            </div>
                          </div>
                          @if (isUnfolded) {
                            <div class="sub-step-name">
                              {{ subStep.name }}
                            </div>
                          }
                        </li>
                      }
                      <li
                        role="link"
                        [routerLink]="step.routerLink"
                        [routerLinkActiveOptions]="{ exact: true }"
                        routerLinkActive="active"
                        class="result-substep done"
                        data-cy="result-step"
                      >
                        <div [title]="!isUnfolded ? 'Ergebnis' : ''" class="progress-part">
                          <div class="line"></div>
                          <div class="circle">
                            <mat-icon>functions</mat-icon>
                          </div>
                        </div>
                        @if (isUnfolded) {
                          <div class="sub-step-name" i18n>Ergebnis</div>
                        }
                      </li>
                    </ul>
                  }
                </div>
              }
            </div>
          }
        </div>
      </ul>
    </div>
  </div>

  <div class="bottom-container">
    @if (!isSidenavOver) {
      <button (click)="toggleUnfold()" mat-icon-button class="unfold-toggle">
        @if (isUnfolded) {
          <mat-icon>navigate_before</mat-icon>
        } @else {
          <mat-icon>navigate_next</mat-icon>
        }
      </button>
    }
    @if (isUnfolded) {
      <dt-legal></dt-legal>
    }
  </div>
</div>
